import { ProfilePageTabId } from '@colonist/clientforge';
import { setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { UIProfileSettingsController } from '../../../shared/scripts/profile/UIProfileSettingsController.ts';
import { navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { showPlayerEditProfileDialog } from '../../../shared/scripts/ui_popup/edit_profile_dialog/showEditProfileDialog.ts';
import { ProfileEditAjaxEndPoints } from '../../../shared/scripts/profile/ProfileEditAjaxEndPoints.ts';
import { showDeviceInfoDialog } from '../../../shared/scripts/ui_popup/showDeviceInfoDialog.ts';
export class UIWProfileSettingsController extends UIProfileSettingsController {
    init() {
        this.profileIsCurrentUser = this.isProfileCurrentUser();
        if (!this.profileIsCurrentUser) {
            this.hideSettingsTab();
            this.redirectToMainProfileSection();
            return;
        }
        this.initEditProfileButton();
        this.initDeviceInfoButton();
    }
    isProfileCurrentUser() {
        if (ClientUserState.userState == undefined) return false;
        return ClientUserState.userState.username.toLowerCase() == decodeURIComponent(this.username.toLowerCase());
    }
    hideSettingsTab() {
        this.profileLinkController.setTabVisible(ProfilePageTabId.Settings, false);
    }
    showSettingsTab() {
        this.profileLinkController.setTabVisible(ProfilePageTabId.Settings, true);
    }
    redirectToMainProfileSection() {
        if (this.profileLinkController.activeTabId != ProfilePageTabId.Settings) return;
        navigateToPage(`/profile/${this.username}`);
    }
    initEditProfileButton() {
        setElementOnClick(this.editProfileButton, ()=>{
            showPlayerEditProfileDialog({
                selectColorAction: async (color)=>await ProfileEditAjaxEndPoints.updatePreferredColor(color)
            });
        });
    }
    initDeviceInfoButton() {
        setElementOnClick(this.deviceInfoButton, ()=>{
            var _window_navigator_userAgentData, _window_navigator;
            var _window_navigator_userAgentData_platform;
            return showDeviceInfoDialog({
                width: document.body.clientWidth,
                height: document.body.clientHeight,
                userAgent: navigator.userAgent,
                platform: (_window_navigator_userAgentData_platform = (_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_userAgentData = _window_navigator.userAgentData) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) !== null && _window_navigator_userAgentData_platform !== void 0 ? _window_navigator_userAgentData_platform : navigator.platform,
                cookieEnabled: navigator.cookieEnabled
            });
        });
    }
    constructor(username, profileLinkController){
        super();
        this.username = username;
        this.profileLinkController = profileLinkController;
        this.editProfileButton = document.getElementById('page-profile-edit-profile');
        this.deviceInfoButton = document.getElementById('page-profile-device-info');
        this.init();
    }
}
